/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ConfigService } from './config/config.service';
import { PreloaderService } from './preloader/preloader.service';
import { SpinnerService } from './spinner/spinner.service';
import { NotificationService } from './notification.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@NgModule({
  imports: [
    MatSnackBarModule,
    MatProgressBarModule,
  ],
  providers: [
    ConfigService,
    PreloaderService,
    SpinnerService,
    NotificationService,
  ],
  declarations: [
    SpinnerComponent
  ],
  exports: [],
  entryComponents: [
    SpinnerComponent
  ],
})

export class ServicesModule {
  constructor(@Optional() @SkipSelf() parentModule: ServicesModule) {
  }
}
